<div class="container">
  <div class="contact-content">
    <h2>Contact</h2>
    
    <div class="contact-section">
      <p>
        If you would like to provide feedback on or have questions about this website, please contact CHDI at 
        <a href="mailto:info@chdifoundation.org?subject=inquiry%20regarding%20GEM-HD%20query%20tool">info&#64;chdifoundation.org</a> 
        and include "inquiry regarding GEM-HD query tool" in the Subject of the message.
      </p>
    </div>
  </div>
</div>